import { Badge } from '@optools/components/ui/badge';
import { cn } from '@optools/components/ui/utils';

import { getOverrideStatus } from '../utils';

export interface StatusBadgeProps {
  expiration: string;
}

export function StatusBadge({ expiration }: StatusBadgeProps) {
  const status = getOverrideStatus(expiration);

  return (
    <Badge
      className={cn({
        'border-green-700 bg-green-700/20 text-green-700': status === 'Active',
        'border-yellow-700 bg-yellow-700/20 text-yellow-700': status === 'Expired',
      })}
      variant="outline">
      {status}
    </Badge>
  );
}
